export default __webpack_public_path__ + "static/media/throne.24f3983c.png";